import Draggable from 'react-draggable';
import "../ImportProgressLoader.css";
import { InfoCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

type Props = {
  success: number,
  scanned: number,
  duplicates: number,
  falsePositives: number,
  percent: number,
  visibility: string,
}

const ImportProgressLoader = (props: Props) => {
  const [isGrabbing, setIsGrabbing] = useState(false);
  const hideImportPanel = true;

  const handleMouseDown = () => {
    setIsGrabbing(true);
  };

  const handleMouseUp = () => {
    setIsGrabbing(false);
  };

  return(
    <Draggable>
      <div
        id="inProgressPanel"
        className={hideImportPanel ? "hidden" : props.visibility}
        style={{ cursor: isGrabbing ? 'grabbing' : 'grab' }}
      >
        <div
          className="flex flex-col min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
        >
          <div
            className="w-[100%] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-6 pb-6 pt-6 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 w-full">
                  <h3 className="text-2xl mb-4 font-semibold leading-6 text-gray-900" id="modal-title">
                    Importing Leads into Innlead
                  </h3>
                  <div id="progresspercent" className="mb-4 text-gray-700 font-medium">{props.percent}% Done</div>
                  <div className="progress h-3 rounded-full"> 
                    <div className="progressbar rounded-full" style={{ width: props.percent + "%", }}></div> 
                  </div> 
                  <div className="flex flex-col mt-6 space-y-3">
                    <div id="progressstatus">
                      <div className="flex items-center space-x-2">
                        <InfoCircleOutlined className="text-gray-700" />
                        <p className="text-gray-700"><span id="scanprogress">{props.scanned}</span> scanned</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <CheckCircleOutlined className="text-green-500" />
                        <p className="text-gray-700"><span id="successprogress">{props.success}</span> success</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <ExclamationCircleOutlined className="text-yellow-500" />
                        <p className="text-gray-700"><span id="duplicateprogress">{props.duplicates}</span> duplicates</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <CloseCircleOutlined className="text-red-500" />
                        <p className="text-gray-700"><span id="falseprogress">{props.falsePositives}</span> false positives</p>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 flex justify-start mt-6 rounded-lg">
                      <button id="stopSearching" type="button" className="bg-gradient-to-r from-red-500 to-red-600 p-2 rounded-md text-white hover:from-red-600 hover:to-red-700 transition-all shadow-md">
                        Stop Import
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Draggable>
    );
}

export default ImportProgressLoader;